import { createContext, useContext } from 'react';

/**
 * Called when the user follows an entity link inside a chat message, right before the app
 * navigates in the same tab. Each surface uses it to stay usable across that navigation: the
 * floating panel leaves expanded mode, the full AI page hands its thread over to the floating
 * panel. Defaults to a no-op so a message renders fine outside any surface.
 */
const AiChatInternalLinkContext = createContext<() => void>(() => {});

export const AiChatInternalLinkProvider = AiChatInternalLinkContext.Provider;

export const useAiChatInternalLinkHandler = () => useContext(AiChatInternalLinkContext);
